import React, { useState, useEffect, useRef } from "react";
import Male from "../SmcLife/Images/male-icon2.svg";
import Female from "../SmcLife/Images/female-icon2.svg";
import MaskedInput from "react-text-mask";
import Mobile from "../SmcLife/Images/mobile.svg";
import email from "../SmcLife/Images/mail.svg";
import google from "../SmcLife/Images/GoogleReview.webp";
import rattings from "../SmcLife/Images/ratings.svg";
import OtherLink from "./OtherLink";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "../SmcLife/UtilityComponents/CustomDatePicker";
import { FilterData } from "./UtilityComponents/FilterData";
import { MdKeyboardArrowRight } from "react-icons/md";
import { calculateAge, AnnualIncomeArr, convertIntoLakh, CalculateUserAge, mobilePattern } from "./UtilityComponents/UtilityFunction";
import moment from "moment";
import { useFormik } from 'formik';

const LifeForm = (props) => {
    const [Error, setError] = useState({});
    const [AgeList, setAgeList] = useState([]);
    const [IsOccupationDisabled, setIsOccupationDisabled] = useState(false)
    const [IsFromHouseWifeComponent, setIsFromHouseWifeComponent] = useState(false);
    const [MaxDate, setMaxDate] = useState(null);
    const [MinDate, setMinDate] = useState(null);
    const [getMobile, setGetMobile] = useState(props.getMobileNumber);
    const [step, setStep] = useState(1);
    const [formDetails, setFormDetails] = useState({
        Occupation: "",
        Education: "",
        Gender: ["women-term", "housewife-term"].includes(props.InsuranceType) ? "F" : "M",
        MobileNo: "",
        Email: "",
        Smoker: "N",
        AnnualIncome: null,
        CoverTillAge: null,
    });

    const initialValues = {
        Occupation: "",
        Education: "",
        Gender: ["women-term", "housewife-term"].includes(props.InsuranceType) ? "F" : "M",
        MobileNo: "",
        Email: "",
        Smoker: "N",
        AnnualIncome: null,
        CoverTillAge: null,
        DOB:null
    }
    const occupationRef = useRef(null);
    const coverTillAgeRef = useRef(null);

    const validate = (values) => {

        let error = {};
        if (step === 1) {
            if (values.DOB === "" || values.DOB === "Date OF Birth") {
                error["DOB"] = "Select Date Of Birth";
            }

            if (values.MobileNo === "") {
                error["MobileNo"] = "Please enter mobile number";
            }
            else if (values.MobileNo.length !== 10) {
                error["MobileNo"] = "Please enter valid mobile number";
            }
            else if (values.MobileNo === "9999999999" || values.MobileNo === "8888888888" || values.MobileNo === "7777777777" || values.MobileNo === "6666666666") {
                error["MobileNo"] = "Please enter valid mobile number"
            }
            else if (mobilePattern.test(values.MobileNo)) {
                error["MobileNo"] = "First 6 digits cannot be all the same"
            }

            if (values.Email === "") {
                error["Email"] = "Please enter email";
            } else if (!validateEmail(values.Email)) {
                error["Email"] = "Please enter valid email ";
            } else if (values.Email.includes("..")) {
                error["Email"] = "Please enter valid email ";
            } else if (
                values.Email.slice(0, 1) === "." ||
                values.Email.slice(0, 1) === "-"
            ) {
                error["Email"] = "Please enter valid email";
            }

            if (values.Education === "") {
                error["education"] = "Please select education";
            }

            // Check for occupation only if it's not housewife
            if (!IsFromHouseWifeComponent && values.Occupation === "") {
                error["occupation"] = "Please select occupation";
            }
            if (getAge(values.DOB) > 65) {
                error["DOB"] = "Age should be less than or equal to 65 years";
            }
        } else if (step === 2) {

            //let value = formDetails?.AnnualIncome?.value

            if (Number(values.AnnualIncome) < 1 || isNaN(Number(values.AnnualIncome))) { 
                error["AnnualIncome"] = "Please choose annual income"
        }

        if (Number(values.CoverTillAge) < 1 || isNaN(Number(values.CoverTillAge))) {
            error["coverAge"] = "Please choose cover till age"
            }
        }
        return error;
    }


    const { values, setValues, handleChange, handleBlur, touched, errors, setFieldValue, setFieldTouched, validateForm, handleSubmit } = useFormik({
        initialValues,
        validate,
        enableReinitialize:true,
        onSubmit: (values) => {
            continueToQuote(values);
        }
    })

    useEffect(() => {
        if (props.request && !props.IsInitialForm) {
            const { Gender, MobileNo, Email, IsSmoker, AnnualIncome, CoverTillAge, DoB, Occupation, Education } = props.request;
         
            console.log({props})

            setValues({
                ...values, Gender: ["women-term", "housewife-term"].includes(props.InsuranceType) ? "F" : (Gender || "M"),
                MobileNo: MobileNo || "",
                Email: Email || props.request.EmailID || "",
                Smoker: IsSmoker === true ? "Y" : "N" ,
                AnnualIncome: AnnualIncome || null,
                CoverTillAge: CoverTillAge,
                Education: Education,
                Occupation: Occupation,
                DOB: new Date(DoB)
})

        }

        setIsFromHouseWifeComponent(props.InsuranceType.toLowerCase() === "housewife-term")

    }, [props.request, props.componentType]);

    useEffect(() => {
        if (props.InsuranceType.toLowerCase() === "housewife-term" && props.OccupationList.length > 0) {
            const occupation = props.OccupationList.find(item => item.id === '82');
            setFieldValue('Occupation', occupation.id);
        }
    }, [props.OccupationList]);


    useEffect(() => {
        if (["housewife-term"].includes(props.InsuranceType)) {
            setIsOccupationDisabled(true)
        }

        if (!["women-term", "housewife-term", "2cr-term"].includes(props.InsuranceType)) {
            let annualArr = AnnualIncomeArr()?.find(r => r.value === 500000);
            setFieldValue('AnnualIncome', annualArr.value);
        }

    }, [])

    useEffect(() => {
        if (!["women-term", "2cr-term", "housewife-term"].includes(props.InsuranceType) && values.DOB && props.IsInitialForm ) {
            const age = getAge(values.DOB);
            setFieldValue('CoverTillAge', age > 85 ? 100 : age + 15);
        }
    }, [values.DOB, values.CoverTillAge]);

    useEffect(() => {
        //const minDate = moment().subtract(66, 'years').endOf('day');
        const minDate = moment().subtract(66, 'years').add(1, 'day').startOf('day')
        setMinDate(minDate.toDate());
        const maxDate = moment().subtract(18, 'years').endOf('day');
        setMaxDate(maxDate.toDate());
        setFieldValue('DOB', maxDate.toDate())
    }, [])


    const validateEmail = (email) => {
        return /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/.test(
            String(email).toLowerCase()
        );
    };

    const getAge = (dob) => {
        try {
            let today = new Date();
            let birthDate = new Date(dob);
            let age = today.getFullYear() - birthDate.getFullYear();
            let month = today.getMonth() - birthDate.getMonth();
            if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        } catch (er) {
            return 0;
        }
    };



    useEffect(() => {
        console.log("run")
        if (values.Gender === "M" && values.Occupation === "82") {
            setFieldValue('Occupation', '');
        }
    }, [values.Gender]);

    useEffect(() => {
        if (values.DOB) {
            setAgeList(calculateAge(getAge(values.DOB)));
        }
    }, [values.DOB]);

    useEffect(() => {
        let mobileFromSession = sessionStorage.getItem('MobileNo');
        if (mobileFromSession) {
            mobileFromSession = JSON.parse(mobileFromSession);
            setFieldValue('MobileNo', mobileFromSession);
        }
    }, []);


    useEffect(() => {
      if (values.MobileNo) {
            setGetMobile(formDetails.MobileNo);

        }
    }, [values.MobileNo]);

  
    const submitForm =async () => {
        const validationErrors = await validateForm();
        if (Object.keys(validationErrors).length === 0) {
        props.setInitialForm(false);
        props.onGetMobileChange(getMobile);
            setStep(2); // Proceed if no errors
        }

    }

    const continueToQuote = (values) => {

        let req = {
            Gender: values.Gender,
            Error,
            MobileNo: values.MobileNo,
            Email: values.Email,
            DOB:values.DOB,
            AnnualIncome: values.AnnualIncome,
            CoverTillAge: values.CoverTillAge,
            Smoker: values.Smoker,
            Occupation: values.Occupation,
            Education: values.Education
        };
        //console.log('----req----:,', req)

        props.submitForm(req);
    }

    const handleSelectEducation = (data) => {
        setFieldValue('Education', data.CODE);
        setFieldTouched('Education', true);
        if (!values.Occupation) {
        occupationRef.current.autoOpenDropdown();
        }
    }

    return (
        <>
            {props.IsInitialForm ? (
                <div className="IndexLife-cards">
                    <form action="">
                        <p className="Index_cardTitle">Please Enter Your Details</p>
                        {!["women-term", "housewife-term"].includes(props.InsuranceType) &&
                            < div >
                                <label className="Index_cardTitle2">Gender</label>
                                <label className="Index_cardTitle2">
                                    <input
                                        type="radio"
                                        value="M"
                                        name="Gender"
                                        checked={values.Gender === "M"}
                                        onChange={handleChange}
                                    />
                                    <img src={Male} className="IndexMainIpict" alt="Male" />
                                    <span>Male</span>
                                </label>

                                <label className="Index_cardTitle2">
                                    <input
                                        type="radio"
                                        value="F"
                                        name="Gender"
                                        checked={values.Gender === "F"}
                                        onChange={handleChange}
                                    />
                                    <img src={Female} className="IndexMainIpict " alt="Female" />
                                    <span>Female</span>
                                </label>
                            </div>}
                        <div className="user-input-wrp my-4">
                            <span className="fixed_label">Date of Birth</span>
                            <CustomDatePicker
                                setDOB={(date) => { setFieldValue('DOB', date); setFieldTouched('DOB', true); }}
                                minDate={MinDate}
                                maxDate={MaxDate}
                                RegDate={values.DOB}
                                
                            />
                            {errors.DOB && touched.DOB && <span className="errors-msg">{errors["DOB"]}</span>}
                            <small className="UserAge"><b>{getAge(values.DOB)} years</b></small>
                        </div>

                        <div className="user-input-wrp my-4" id="mobileno">
                            <MaskedInput
                                className="inputText"
                                mask={[
                                    /[6-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                required
                                showMask={false}
                                name="MobileNo"
                                value={values.MobileNo}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            // onChange={(e) => setMobileNo(e.target.value)}
                            />
                            {errors.MobileNo && touched.MobileNo && <span className="errors-msg">{errors["MobileNo"]}</span>}
                            <span className="floating-label">Mobile Number</span>
                            <img src={Mobile} className="cellphone" alt="Mobile" />
                        </div>
                        <div className="user-input-wrp my-4" id="Emailid">
                            <input
                                type="text"
                                className="inputText emailInput pe-4"
                                required
                                autoComplete="on"
                                onKeyDown={(e) => {
                                    // Prevent typing multiple consecutive spaces
                                    const { value, selectionStart } = e.target;
                                    if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                        e.preventDefault();
                                    }
                                }}
                                name="Email"
                                value={values.Email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.Email && touched.Email && <span className="errors-msg">{errors["Email"]}</span>}
                            <span className="floating-label">Email Address</span>
                            <img src={email} className="mail" alt="Email" />
                        </div>

                        <div className="user-input-wrp">
                            <span className="DropDown_label">Select Your Education</span>
                            <FilterData
                                ArrayList={props?.EducationList}
                                FilterKey={"CODE"}
                                onSelect={(data) => handleSelectEducation(data)}
                                DefaultTitle={values.Education ? props.EducationList.find(option => option.CODE === values.Education)?.Name : "Education"}
                                ListNameKey={"Name"}
                                className="filter_dropdwon"

                            />
                        </div>

                        <div className="user-input-wrp">
                            {!IsFromHouseWifeComponent &&
                                <>
                                    <span className={`DropDown_label ${IsFromHouseWifeComponent ? 'DropDown_label_disabled' : ''}`}>Select Your Occupation</span>
                                    <FilterData
                                    ArrayList={values.Gender === "M" ? props?.OccupationList.filter(item => item.id !== '82') : props?.OccupationList}
                                    FilterKey={"id"}
                                    onSelect={(data) => {
                                        // setFormDetails((prev) => ({ ...prev, Occupation: data.id }));
                                        setFieldValue('Occupation', data.id);
                                        setFieldTouched('Occupation', true)
                                    }}
                                    DefaultTitle={values?.Occupation ? props?.OccupationList?.find(option => option.id == values.Occupation)?.occupation : "Occupation"}
                                    ListNameKey={"occupation"}
                                    className="filter_dropdwon"
                                    ref={occupationRef}
                                    />
                                </>
                            }
                            {/* {console.log(props.OccupationList, "ffff" )}*/}{/**/}
                            {/*<span className={`DropDown_label ${IsOccupationDisabled ? 'DropDown_label_disabled' : ''}`}>Select Your Occupation</span>*/}
                            {/*<select name="Occupation" value={formDetails.Occupation} onChange={handleChange} className="occupation_drop" disabled={IsOccupationDisabled}>*/}
                            {/*    <option value="" disabled >Select Occupation</option>*/}
                            {/*    {props.occupationOptions[formDetails.Gender]?.map((occupation, index) => (*/}
                            {/*        <option key={index} value={occupation.value}>*/}
                            {/*            {occupation.label}*/}
                            {/*        </option>*/}
                            {/*    ))}*/}
                            {/*</select>*/}
                        </div>
                        <button
                            type="button"
                            className="FormGetTouch d-block w-100"
                            disabled={!values.MobileNo || !values.Email || !values.DOB || (getAge(values.DOB) >65 || getAge(values.DOB) <18 ) || !values.Occupation || !values.Education}
                            onClick={() => submitForm()}
                        >
                            {" "}
                            Continue<MdKeyboardArrowRight />
                        </button>
                    </form>

                    <OtherLink />
                    <div className="review_box3">
                        <a className="review_box" href="/customer-reviews" target="_blank">
                            <div className="indem-rate">
                                <img src={google} className="indem_googl" alt="" />
                                <img src={rattings} className="indem_star" alt="" />
                            </div>
                            <p>Highly rated insurance website</p>
                        </a>
                    </div>
                </div>
            ) : (
                <div className="IndexLife-cards">
                    <>
                        <p className="Index_cardTitle">Few More Details</p>
                            <div
                                onClick={() => {
                                    props.setInitialForm(true);
                                    setStep(1);
                                }}
                                className="pre_user_detail previus_detail tooltipdiv"
                            >
                                <span>
                                    <i className="fa fa-arrow-left"></i>
                                </span>
                                <p>
                                    {values.Gender === "M" ? "Male" : "Female"}, {getAge(values.DOB)} years, {values.MobileNo},{" "}
                                    <span className="tooltipemail">
                                        {values.Email.split("@")[0] + "..."}
                                        <div className="tooltipdivinner">
                                            {values.Email}
                                            <div className="tooltip-arrow" />
                                        </div>
                                    </span>
                                </p>
                            </div>


                        <div className="user-input-wrp my-4">

                            <span className="DropDown_label">{props.InsuranceType === "housewife-term" ? "Husband's Approx. Annual Income" : "Select Annual Income"}</span>
                            <FilterData
                                ArrayList={AnnualIncomeArr()}
                                    FilterKey={"value"}
                                    onSelect={(data) => { setFieldValue('AnnualIncome', data.value); if (!values.CoverTillAge) { coverTillAgeRef.current.autoOpenDropdown() } }}
                                DefaultTitle={values?.AnnualIncome ? convertIntoLakh(values.AnnualIncome) : "Annual Income"}
                                ListNameKey={"label"}

                            />
                            <span className="errors-msg">{Error["AnnualIncome"]}</span>
                        </div>

                        <div className="user-input-wrp my-4">


                            <span className="DropDown_label">Select Cover Till Age</span>
                            <FilterData
                                    ArrayList={AgeList}
                                    FilterKey={"value"}
                                    onSelect={(data) => { setFieldValue('CoverTillAge', data.value); setFieldTouched('CoverTillAge', true) }}
                                    DefaultTitle={values?.CoverTillAge ? values.CoverTillAge + ' Years' : "Cover Till Age"}
                                    ListNameKey={"label"}
                                    ref={coverTillAgeRef}

                            />
                            <span className="errors-msg">{Error["coverAge"]}</span>
                        </div>
                        <p className="Index_cardTitle11">Do you smoke or chew tobacco?</p>
                        <div>
                            <label className="Index_cardTitle2 Index_cardTitle3 ">
                                <input
                                    type="radio"
                                    value="N"
                                    name="Smoker"
                                    checked={values.Smoker === "N"}
                                    onChange={handleChange}
                                />
                                No
                            </label>
                            <label className="Index_cardTitle2">
                                <input
                                    type="radio"
                                    value="Y"
                                    name="Smoker"
                                    checked={values.Smoker === "Y"}
                                    onChange={handleChange}
                                />
                                Yes
                            </label>
                        </div>
                        <p className="lifecheck">
                            Choose 'Yes' if you have smoked or chewed tobacco in last 1 year
                        </p>

                            <button
                                onClick={handleSubmit}
                            type="button"
                            className="FormGetTouch d-block w-100 mb-1"
                            disabled={!values.AnnualIncome || !values.CoverTillAge}
                        >
                            {props.BtnVal}<MdKeyboardArrowRight />
                        </button>
                        <p className="mb-0">
                            <small>By clicking I agree to all</small>{" "}
                            <span className="textcolor">
                                <a onClick={() => window.open("https://www.smcinsurance.com/terms-of-use", "_blank")}>
                                    T&C
                                </a>
                            </span>
                        </p>

                        <OtherLink />
                        <div className="review_box3">
                            <a
                                className="review_box"
                                href="/customer-reviews"
                                target="_blank"
                            >
                                <div className="indem-rate">
                                    <img src={google} className="indem_googl" alt="" />
                                    <img src={rattings} className="indem_star" alt="" />
                                </div>
                                <p>Highly rated insurance website</p>
                            </a>
                        </div>
                    </>
                </div>
            )}
        </>
    );
};
export default LifeForm;
